import classNames from 'clsx';
import React, { useContext } from 'react';

import CreateTournamentContext from '../CreateTournamentContext/CreateTournamentContext';
import useWizardNav from '../hooks/useWizardNav';
import { ModalPages, ModalPagesNames, ModalPagesRoutes, totalPages } from '../utils/common';

import styles from './PaginationDots.scss';

interface Props {
  pages?: string[];
}

const PaginationDots: React.FC<Props> = ({ pages = ModalPagesNames }) => {
  const {
    state: { activePage }
  } = useContext(CreateTournamentContext);
  const goTo = useWizardNav(activePage, totalPages);

  return (
    <div className={styles.dots}>
      {pages.map((page, index) => {
        const isActive = activePage === index;
        return (
          <span
            key={page}
            className={classNames(styles.dot, { [styles.active]: isActive })}
            onClick={() => goTo(ModalPages[page], ModalPagesRoutes[index])}
          ></span>
        );
      })}
    </div>
  );
};

export default PaginationDots;
